import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute, ResolveData } from '@angular/router';
import { EncryptionAndDecryption } from 'src/app/COMMON-LOGIC/EncryptionAndDecryption';
import { CustomErrorsHandlerService } from 'src/app/_services/custom-errors-handler.service';
import { ParticipationDataService } from 'src/app/_services/participation-data.service';
import { SurveyDecode } from 'src/app/common-class/survey-decode';
import { SurveyDecodeSearchModel } from 'src/app/common-class/survey-properties';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-survey-decode',
  templateUrl: './survey-decode.component.html',
  styleUrls: ['./survey-decode.component.css'],
})
export class SurveyDecodeComponent implements OnInit {
  urlParam: string;
  stralertModel: string;
  ForbiddenTitle: string;
  isMobile: boolean;
  clienturl: string;
  static_host: boolean;
  PrivacyPolicy: string;
  ErrorText: boolean;
  err: number;
  showLoader: boolean = true;
  productTitle: string = '';
  surveyDecode: SurveyDecode;
  surveyDecodeSearchModel: SurveyDecodeSearchModel;

  constructor(
    public service: ParticipationDataService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private errorsHandlerService: CustomErrorsHandlerService,
    private titleService: Title,
  ) {}

  ngOnInit(): void {
    let URlData = this.GetUrlData();
    let strDecodeUrl = 'surveydecode';
    this.productTitle = environment.productName;
    this.service
      .postDataUsingPromise(
        strDecodeUrl,
        JSON.stringify(
          EncryptionAndDecryption.EncryptionData(
            '123456$#@$^@1ERF',
            JSON.stringify(this.surveyDecodeSearchModel),
          ),
        ),
      )
      .then(
        async (data) => {
          var arrData = EncryptionAndDecryption.DecryptionData('123456$#@$^@1ERF', await data);
          this.surveyDecode = await JSON.parse(arrData);
          this.showLoader = false;

          const head = document.getElementsByTagName('head')[0];

          let node = document.createElement('script'); // creates the script tag
          node.src = 'survey/assets//js/Anuglar_Survey_jquery.min.js?v=30052022'; // sets the source (insert url in between quotes)
          node.type = 'text/javascript'; // set the script type
          let node1 = document.createElement('script'); // creates the script tag
          node1.src = 'survey/assets//js/jquery-ui.min.js?v=30052022'; // sets the source (insert url in between quotes)
          node1.type = 'text/javascript'; // set the script type
          let node2 = document.createElement('script'); // creates the script tag
          node2.src = 'survey/assets//js/Survey_jquery.nicescroll.js'; // sets the source (insert url in between quotes)
          node2.type = 'text/javascript'; // set the script type
          let node4 = document.createElement('script'); // creates the script tag
          node4.src = 'survey/assets//js/Survey_jquery.ui.touch-punch.min.js?ver=13.0'; // sets the source (insert url in between quotes)
          node4.type = 'text/javascript'; // set the script type

          const style2 = document.createElement('link');
          style2.id = 'css-styling';
          style2.rel = 'stylesheet';
          style2.href = 'survey/assets/jquery-ui.min.css?key=11.25.25-07-2018';
          const style3 = document.createElement('link');
          style3.id = 'css-styling';
          style3.rel = 'stylesheet';
          style3.href = 'survey/assets/ng-common-pm.css';

          head.appendChild(style2);
          head.appendChild(style3);
          head.appendChild(node);
          head.appendChild(node1);
          head.appendChild(node2);
          head.appendChild(node4);

          setTimeout(() => {
            if (this.surveyDecode.isSurvey) {
              window.location.replace(this.surveyDecode.redirectURL);
            } else {
              const elements = document.querySelectorAll('.message-wrapper') as NodeListOf<HTMLElement>;
              elements.forEach(elList => {
                elList.style.display = 'block';
              });
            }
          }, 0);

          this.showLoader = false;
        },
        (error) => {
          this.showLoader = false;
          this.errorsHandlerService.handleError(error);
          if (error.name == 'HttpErrorResponse') {
            window.location.replace('..survey/sd?err=1&ng=2&cn=0');
          }
        },
      );
  }

  GetUrlData(): any {
    this.activatedRoute.queryParams.subscribe(async (params) => {
      let k = params['k'] == '' || params['k'] == undefined ? '' : params['k'];
      let k2 = params['k2'] == '' || params['k2'] == undefined ? '' : '&k2=' + params['k2'];
      let k1 = params['k1'] == '' || params['k1'] == undefined ? '' : '&k1=' + params['k1'];
      let corpno = params['cn'] == '' || params['cn'] == undefined ? '' : '&cn=' + params['cn'];
     
      let prlang =
        params['prlang'] == '' || params['prlang'] == undefined
          ? ''
          : '&prlang=' + params['prlang'];
      let lang = params['lang'] == '' || params['lang'] == undefined ? '0' : params['lang'];
      let err = params['err'] == '' || params['err'] == undefined ? '' : '&err=' + params['err'];
      this.urlParam = 'k=' + k + '&lang=' + lang + k1 + k2 + corpno + prlang + err;

      this.surveyDecodeSearchModel = new SurveyDecodeSearchModel();
      this.surveyDecodeSearchModel.k = k;
      this.surveyDecodeSearchModel.cn =
        params['cn'] == '' || params['cn'] == undefined ? 0 : params['cn'];
      this.surveyDecodeSearchModel.prlang =
        params['prlang'] == '' || params['prlang'] == undefined ? 0 : params['prlang'];
      this.surveyDecodeSearchModel.lang = lang;
      this.surveyDecodeSearchModel.err =
        params['err'] == '' || params['err'] == undefined ? '' : '' + params['err'];
      this.surveyDecodeSearchModel.strClienturl =  params['curl'] == '' || params['curl'] == undefined ? 0 : params['curl'];
    });
    return this.urlParam;
  }
}
